import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import WorkflowDrawingGuardStore from '~/client/src/shared/stores/ui/WorkflowDrawingGuard.store'
import { getFullscreenElement } from '~/client/src/shared/utils/fullscreenElement'

interface IProps {
  store: WorkflowDrawingGuardStore
}

// A leaf observer on purpose — inlining these reads (confirm state + fullscreen) would
// re-render the whole overlay instead of just this dialog.
const WorkflowDrawingGuardDialog: React.FC<IProps> = observer(({ store }) => {
  // Portal into the fullscreen element — a body portal renders outside it (invisible).
  const fullscreenEl = getFullscreenElement() as HTMLElement | null
  return (
    <ConfirmDialog
      isOpen={store.isConfirmShown}
      onDoneClicked={store.onDialogConfirm}
      onCancelClicked={store.onDialogCancel}
      title={Localization.translator.discardWorkflowDraft}
      question={Localization.translator.discardWorkflowDraftQuestion}
      doneTitle={Localization.translator.discard}
      useRedConfirmationButton
      portalContainer={fullscreenEl ? { current: fullscreenEl } : undefined}
    />
  )
})

export default WorkflowDrawingGuardDialog
